import { Link as RouterLink } from "react-router-dom";
import styled from "styled-components";

const styles = (props) => {
  const minimalStyles = `
    text-decoration: none !important;
  `;
  
  const sharedStyles = `
    ${minimalStyles}
    background: transparent;
    border: 1px solid transparent;
    border-radius: 4px;
    color: rgb(95, 100, 121) !important;
    font-family: 'Titillium Web', sans-serif;
    font-size: 1rem;
    margin: 0 8px;
    padding: 5px 10px;
    transition: all .1s ease-out;

    &:hover {
      color: rgb(252, 177, 46) !important;
    }

    ${props.highlight ? 'color: #fcb12d !important' : ''}
  `

  return props.minimal ? minimalStyles : sharedStyles;
};

const StyledAnchor = styled.a`${styles}`;

const StyledLink = styled(RouterLink)`${styles}`;

export const Link = ({
  to,
  label,
  children,
  highlight,
  external = false,
  minimal = false,
}) => {
  if (external) {
    return (
      <StyledAnchor href={to} minimal={minimal} highlight={highlight} target="_blank">
        {label || children}
      </StyledAnchor>
    )
  }

  return (
    <StyledLink to={to} minimal={minimal} highlight={highlight}>
      {label || children}
    </StyledLink>
  )
}